import styled from 'styled-components'

import { MapPinIcon } from 'assets/icons'

export const MapPin = styled(MapPinIcon)`
  width: 55px;
  height: 55px;
  transform: translate(5%, -35%) !important;
`
